
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import Project from "@/types/project/project"
import Tracking from "@/types/tracking/tracking"
import VueI18n from "vue-i18n"
import LocaleMessage = VueI18n.LocaleMessage
import ExpenditureDialog from "@/components/Expenditure/ExpenditureDialog.vue"
import Expenditure from "@/types/expenditure/expenditure"
import { ExpenditureService } from "@/services/timetrack/ExpenditureService"
import CreateProject from "@/components/Project/CreateProject.vue"
import { ProjectService } from "@/services/timetrack/ProjectService"
import { TimesService } from "@/services/timetrack/TimesService"

@Component({
  filters: {
  },
  components: {
    ExpenditureDialog,
    CreateProject
  }
})
export default class TrackingFieldsFinishedTracking extends Vue {
  private expenditureDialog = false
  private createProjectDialog = false
  private task: string | null = null
  private selectedProject: Project | null = null

  @Prop({ required: true, default: null })
  private projects!: Project[];

  @Prop({ required: true, default: null })
  private tracking!: Tracking;

  @Prop({ required: true, default: null })
  private tasks!: string[] | LocaleMessage[];

  @Prop({ required: true, default: null })
  private making!: string;

  private projectService = new ProjectService()
  private timeService = new TimesService()
  private expenditureService = new ExpenditureService()

  created () {
    this.fillFormWithData()
  }

  @Watch('tracking')
  private fillFormWithData () {
    if (!this.tracking) this.resetForm()
    if (this.tracking) {
      if (this.tracking.projectId && this.projects) {
        this.selectedProject = this.projects.filter((project) => { return project.id === this.tracking.projectId })[0]
      }
    }
    if (this.tracking && this.tracking.task) {
      this.task = this.tracking.task
    }
  }

  private get badgeValue () {
    if (!this.tracking || !this.tracking.expenditures) return 0
    return this.tracking.expenditures.length
  }

  private get currentExpenditureValue () {
    if (!this.tracking || !this.tracking.expenditures || this.tracking.expenditures.length < 1) return 0
    return this.tracking.expenditures
      .map((expenditure) => { return expenditure.totalPrice })
      .reduce((a, b) => {
        if (!a || !b) return null
        return a + b
      })
  }

  private selectedProjectChanged () {
    if (!this.tracking || !this.tracking.id) return
    this.$emit('loading')
    this.timeService.updateProject(this.tracking.id, this.selectedProject?.id || undefined)
      .then(() => {
        this.$emit('trackingChanged')
      }).catch((error) => {
        this.$store.dispatch('error/setError', error)
      }).finally(() => {
        this.$emit('loading')
      })
  }

  private taskChanged () {
    if (!this.tracking || !this.tracking.id) return
    this.$emit('loading')
    this.timeService.updateTask(this.tracking.id, this.task || undefined)
      .then(() => {
        this.$emit('trackingChanged')
      }).catch((error) => {
        this.$store.dispatch('error/setError', error)
      }).finally(() => {
        this.$emit('loading')
      })
  }

  private updateExpenditure (expenditureData: Expenditure) {
    if (!expenditureData || !expenditureData.id) return
    this.$emit('loading')
    this.expenditureService.updateExpenditureData(expenditureData.id, expenditureData)
      .then(() => {
        this.$emit('trackingChanged')
      }).catch((error) => {
        this.$store.dispatch('error/setError', error)
      }).finally(() => {
        this.$emit('loading')
      })
  }

  private storeExpenditureAtCurrentTracking (expenditureData: Expenditure) {
    if (!this.tracking || !this.tracking.id || !expenditureData) return
    this.$emit('loading')
    this.expenditureService.storeExpenditureForTracking(this.tracking.id, expenditureData)
      .then(() => {
        this.$emit('trackingChanged')
      }).catch((error) => {
        this.$store.dispatch('error/setError', error)
      }).finally(() => {
        this.$emit('loading')
      })
  }

  private deleteExpenditure (expenditure: Expenditure) {
    if (!expenditure || !expenditure.id) return
    this.$emit('loading')
    this.expenditureService.removeExpenditureById(expenditure.id)
      .then(() => {
        this.$emit('trackingChanged')
      }).catch((error) => {
        this.$store.dispatch('error/setError', error)
      }).finally(() => {
        this.$emit('loading')
      })
  }

  private saveProject (projectData: Project) {
    if (!projectData) {
      return
    }
    this.projectService.createProject(projectData)
      .then(() => {
        this.$emit('projectCreated')
      })
      .catch((error) => {
        this.$store.dispatch('error/setError', error)
      }).finally(() => {
        this.createProjectDialog = false
      })
  }

  private resetForm () {
    this.selectedProject = null
    this.task = null
  }
}
